import { render, staticRenderFns } from "./InviteDistributor.vue?vue&type=template&id=8e35fff0&scoped=true"
import script from "./InviteDistributor.vue?vue&type=script&lang=js"
export * from "./InviteDistributor.vue?vue&type=script&lang=js"
import style0 from "./InviteDistributor.vue?vue&type=style&index=0&id=8e35fff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e35fff0",
  null
  
)

export default component.exports